const sendEVAMCustomEvent = (name: string, data: any) => {
  window?.EvamSdkObject && window?.EvamSdkObject.sendCustomEvent(name, data);
};

export default sendEVAMCustomEvent;
